import {ACTION_TYPES} from 'constants/ActionTypes';

const initialState = {
  items: []
};

export default (state = initialState, action) => {
  let {items} = state;
  switch (action.type) {
    case ACTION_TYPES.ADD_SHOPPING_CARD: {
      return {
        ...state,
        items: items.indexOf(action.data) === -1 ? [action.data, ...items] : items
      };
    }
    case ACTION_TYPES.REMOVE_SHOPPING_CARD: {
      let currentItems = [];
      items.map((item) => {
        if (item !== action.data) {
          currentItems.push(item);
        }
      });
      return {
        ...state,
        items: currentItems
      };
    }
    case ACTION_TYPES.CLEAN_SHOPPING_CARD:
      return {
        ...state,
        items: []
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/shopping-cart.js